(function () {
  var d = document;
  var busy = false;
  function cd() { return d.getElementById('dc-cart-drawer'); }
  function openCart() {
    var el = cd(); if (!el) return;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); d.body.style.overflow = 'hidden';
  }
  function closeCart() {
    var el = cd(); if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); d.body.style.overflow = '';
  }
  /* v4.14.7: tap the design photo in the cart (drawer or cart page) to see it bigger */
  var zoomEl = null;
  function zoomOpen(src) {
    if (!zoomEl) {
      zoomEl = d.createElement('div');
      zoomEl.className = 'dc-czoom';
      zoomEl.setAttribute('role', 'dialog');
      zoomEl.setAttribute('aria-modal', 'true');
      zoomEl.setAttribute('aria-label', 'Your design, enlarged');
      zoomEl.innerHTML = '<button type="button" class="dc-czoom__x" aria-label="Close">&times;</button><p class="dc-czoom__t">Your design</p><img alt="Your design, enlarged"><button type="button" class="dc-czoom__done">Close</button>';
      d.body.appendChild(zoomEl);
      zoomEl.addEventListener('click', function (e) {
        if (e.target === zoomEl || e.target.closest('.dc-czoom__x') || e.target.closest('.dc-czoom__done')) zoomClose();
      });
    }
    zoomEl.querySelector('img').src = src;
    zoomEl.classList.add('is-open');
    try { zoomEl.querySelector('.dc-czoom__done').focus({ preventScroll: true }); } catch (err) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', 'cart_design_zoom'); } catch (err) {}
  }
  function zoomClose() { if (zoomEl) zoomEl.classList.remove('is-open'); }
  function zoomIsOpen() { return !!(zoomEl && zoomEl.classList.contains('is-open')); }
  (function () {
    var st = d.createElement('style');
    st.textContent = '.dc-czoom{display:none;position:fixed;inset:0;z-index:2147483001;background:rgba(43,30,23,.94);align-items:center;justify-content:center;flex-direction:column;gap:14px;padding:20px}' +
      '.dc-czoom.is-open{display:flex}' +
      '.dc-czoom img{max-width:100%;max-height:70vh;object-fit:contain;border-radius:12px;background:#F7F0E6}' +
      '.dc-czoom__t{color:#F7F0E6;font-family:Lora,Georgia,serif;font-size:22px;margin:0;text-align:center}' +
      '.dc-czoom__x{position:absolute;top:10px;right:12px;background:none;border:0;color:#F7F0E6;font-size:32px;line-height:1;padding:6px 10px;cursor:pointer}' +
      '.dc-czoom__done{min-width:150px;background:transparent;border:1.5px solid #F7F0E6;color:#F7F0E6;border-radius:999px;padding:10px 18px;font-size:15px;font-weight:700;cursor:pointer}' +
      '.dc-cd__img:has(img[alt="Your design"]),.dc-line__img:has(img[alt="Your design"]){position:relative;cursor:zoom-in}' +
      '.dc-cd__img:has(img[alt="Your design"])::after,.dc-line__img:has(img[alt="Your design"])::after{content:"";position:absolute;right:4px;bottom:4px;width:22px;height:22px;border-radius:50%;background:rgba(43,30,23,.78) url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23F7F0E6%27 stroke-width=%272.4%27 stroke-linecap=%27round%27%3E%3Ccircle cx=%2711%27 cy=%2711%27 r=%276%27/%3E%3Cpath d=%27M20 20l-4.2-4.2M11 8.5v5M8.5 11h5%27/%3E%3C/svg%3E") center/14px no-repeat;pointer-events:none}';
    d.head.appendChild(st);
  })();

  function bubble(count) {
    d.querySelectorAll('.dc-bubble').forEach(function (b) { b.textContent = count; b.hidden = count === 0; });
  }
  function refresh() {
    return fetch('/?section_id=dc-cart-drawer', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = d.createElement('div'); tmp.innerHTML = html;
      var fresh = tmp.querySelector('#dc-cart-drawer'); var cur = cd();
      if (fresh && cur) {
        var open = cur.classList.contains('is-open');
        cur.replaceWith(fresh);
        if (open) { fresh.classList.add('is-open'); fresh.setAttribute('aria-hidden', 'false'); }
      }
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var prot = 0; (c.items || []).forEach(function (i) { if (i.handle === 'shipping-protection') prot += i.quantity; });
        bubble(c.item_count - prot); return c;
      });
    });
  }
  function post(url, data) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); });
  }
  function onCartPage() { return d.body.classList.contains('template-cart'); }
  function after() { if (onCartPage()) { window.location.reload(); return Promise.resolve(); } return refresh(); }

  d.addEventListener('click', function (e) {
    var zi = e.target.closest('.dc-cd__img, .dc-line__img');
    var zim = zi && zi.querySelector('img[alt="Your design"]');
    if (zim && zim.getAttribute('src')) { e.preventDefault(); zoomOpen(zim.getAttribute('src')); return; }
    var t = e.target.closest('[data-dc-cart-open]');
    if (t && !onCartPage() && cd()) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-dc-cd-close]')) { closeCart(); return; }
    var q = e.target.closest('[data-dc-cd-qty]');
    if (q && !busy) {
      busy = true; q.closest('.dc-cd__line') && q.closest('.dc-cd__line').classList.add('is-busy');
      post('/cart/change.js', { id: q.getAttribute('data-key'), quantity: parseInt(q.getAttribute('data-qty'), 10) })
        .then(after).catch(function () {}).then(function () { busy = false; });
      return;
    }
    var cp = e.target.closest('[data-dc-copy]');
    if (cp) { try { navigator.clipboard.writeText(cp.getAttribute('data-dc-copy')); cp.textContent = 'Copied'; } catch (err) {} }
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { if (zoomIsOpen()) { zoomClose(); return; } closeCart(); } });

  d.addEventListener('change', function (e) {
    var p = e.target.closest('[data-dc-prot]');
    if (!p || busy) return;
    busy = true;
    var req = p.checked
      ? post('/cart/add.js', { items: [{ id: parseInt(p.getAttribute('data-variant'), 10), quantity: 1 }] })
      : post('/cart/change.js', { id: p.getAttribute('data-key'), quantity: 0 });
    req.then(after).catch(function () {}).then(function () { busy = false; });
  });

  /* add to cart: AJAX unless the form opts out (personalized products use the native flow). v4.14.6: logs Clarity cart_added (gift box and other non-photo products). */
  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[action*="/cart/add"]') || !cd()) return;
    var nat = f.getAttribute('data-native');
    if (nat !== null && nat !== 'false') return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]'); if (btn) btn.classList.add('is-loading');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { try { if (typeof window.clarity === 'function') window.clarity('event', 'cart_added'); } catch (x) {} return refresh(); })
      .then(function () { openCart(); })
      .catch(function () { f.setAttribute('data-native', 'true'); f.submit(); })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  /* open drawer after a native add (?cart=open) */
  try {
    var u = new URL(window.location.href);
    if (u.searchParams.get('cart') === 'open') {
      u.searchParams.delete('cart'); window.history.replaceState({}, '', u.toString());
      if (d.readyState === 'complete') { openCart(); } else { window.addEventListener('load', function () { openCart(); }); }
    }
  } catch (err) {}

  /* email popup (home page only, see layout/theme.liquid): once per page view; after X / No thanks / signup it never shows again on that browser; in the theme editor only when its section is selected */
  var pop = d.getElementById('dc-pop');
  if (pop) {
    var key = 'dcPopSeen', dkey = 'dcPopDismissed', days = parseInt(pop.getAttribute('data-days') || '7', 10);
    var seen = 0, dismissed = false;
    try { seen = parseInt(localStorage.getItem(key) || '0', 10); dismissed = localStorage.getItem(dkey) === '1'; } catch (err) {}
    var force = !!pop.querySelector('[data-dc-pop-show]');
    var success = !!pop.querySelector('.dc-pop__code');
    var editor = !!(window.Shopify && window.Shopify.designMode);
    var done = false;
    var mark = function (k, v) { try { localStorage.setItem(k, v); } catch (err) {} };
    var openEl = function (el) { el.hidden = false; requestAnimationFrame(function () { el.classList.add('is-open'); }); };
    var closeEl = function (el) { el.classList.remove('is-open'); setTimeout(function () { el.hidden = true; }, 250); };
    var onExit = function (e) { if (!e.relatedTarget && e.clientY < 10) showPop(); };
    var showPop = function () {
      if (done || !pop.hidden) return;
      if (d.querySelector('.dc-cd.is-open')) return;
      done = true;
      d.removeEventListener('mouseout', onExit);
      openEl(pop); mark(key, String(Date.now()));
    };
    d.addEventListener('click', function (e) {
      var c = e.target.closest && e.target.closest('[data-dc-pop-close]'); if (!c) return;
      var el = c.closest('#dc-pop'); if (!el) return;
      done = true; d.removeEventListener('mouseout', onExit); closeEl(el);
      if (!editor) mark(dkey, '1');
    });
    if (editor) {
      d.addEventListener('shopify:section:select', function (e) { var el = e.target && e.target.querySelector && e.target.querySelector('#dc-pop'); if (el) openEl(el); });
      d.addEventListener('shopify:section:deselect', function (e) { var el = e.target && e.target.querySelector && e.target.querySelector('#dc-pop'); if (el) closeEl(el); });
    } else if (force) { if (success) mark(dkey, '1'); showPop(); }
    else if (!dismissed && (!seen || Date.now() - seen > days * 864e5)) {
      setTimeout(showPop, parseInt(pop.getAttribute('data-delay') || '10', 10) * 1000);
      d.addEventListener('mouseout', onExit);
    }
  }
})();